// PROD
export const environment = {
  production: true,
  DOMAIN: 'https://content.btgpactual.com',
  BASE_DOMAIN: 'https://content.btgpactual.com',
  BASE_URL: 'https://content.btgpactual.com/noticias',
  BASE_HREF: '/noticias',
  SERVER_URL: '/api/research/',
  SERVER_TOOLS_URL: '/api/tools/',
  ASSETS_URL: '',
  CLIENT_ID: '',
  APPLICATION_ID: '',
  PT_FILE_SIZE: '',
  PT_FILE_SIZE_MAX: '3000000',
  PT_FILE_SIZE_MIN: '1',
  PT_FILE_BEAUTY: '.jpg,.jpeg,.gif,.png,.bmp,.docx,.doc,.pdf',
  FSK: "NGY3ZThmYmU5Y2UwY2ViZWMzZDJjMzc2YzQ5ZjA0NDA=",
  BTK: 'SG1tQ0U2cVdNZXpaZm9xWlRjaHZsMjllVGtVZXdRRTc=',
  ICK: "6LdKEfIpAAAAABaHh8MsPzVj3TBMnm0RNi8cuHek",
  WS_SERVICE: 'wss://efs.btgpactualdigital.com/trader/socket',
  APP_ORIGIN: 'research',
  PROJECT: 'RESEARCH',
  RECONNECT_INTERVAL: 3000,
  RECONECT_ATTEMPTS: 5,
  CRIPTO_EDUCATIONAL: 67,
  PORTFOLIO_EXCLUDE_LIST: ['EQI', 'ONE'],
  TIP_RANKS_URL:'/api/tipranks/',
  TIP_INSTRUMENT_URL:'/api/instrument/',
  TIP_MARKET_DATA_URL:'/api/marketdata/',
  ASSETS_IMAGE_BASE: 'https://offshore-content.btg.cloud/assets/logos/',
  TIP_ASSETS_URL:'/assets/api/',
  ONSHORE: true,
  SEARCH_PAGE_DOMAIN: 'https://content.btgpactual.com/',
  PARTNER_REQUEST: 'https://www.btgpactualdigital.com/services/api/rmadmin-whitelabel/partners/cge/',
  EDITH_WS_URL: 'wss://ws.edith.btg.cloud',
  TOPAZ: 'https://btg.dnofd.com/ofdb/OFDB.js',
  OFFSHORE_PORTAL: "https://portal.btgpactual.com/international",
  LOGIN_IMAGE_URL: 'assets/images/onshore90.webp',
  GTM_BASE_URL: 'https://sites-gtm.btgpactual.com',
  GTM_CONTAINER_ID: 'GTM-5V6TSV6',

  oauthconfig: {
    tenente_id: "",
    base_url: 'https://access.btgpactualdigital.com',
    client_id: "94a4966669136887c86dd0613fcf4f34",
    redirect_uri: 'https://content.btgpactual.com/autenticacao/colaborador',
    response_type: 'code',
    response_mode: 'query',
    scope: 'OPENID',
    user_type: 'internal',
    app_name: 'Content',
    state: '',
  },
};
